import {
  getManufacturersData,
  transportUsageTypesRequest,
  getVehiclesData,
  removeManufacturerData,
  removeVehicleModel,
  storeManufacturerData,
  storeVehicleModel,
  updateManufacturerData,
  updateVehicleModel,
} from '../../api/vehicleApi';

const START_REQUEST = 'efes/vehicles/START_REQUEST';
const REQUEST_FAIL = 'efes/vehicles/REQUEST_FAIL';

const GET_VEHICLES_SUCCESS = 'efes/vehicles/GET_VEHICLES_SUCCESS';
const STORE_VEHICLE_SUCCESS = 'efes/vehicles/STORE_VEHICLE_SUCCESS';
const UPDATE_VEHICLE_SUCCESS = 'efes/vehicles/UPDATE_VEHICLE_SUCCESS';
const REMOVE_VEHICLE_SUCCESS = 'efes/vehicles/REMOVE_VEHICLE_SUCCESS';

const GET_MANUFACTURERS_SUCCESS = 'efes/manufacturers/GET_MANUFACTURERS_SUCCESS';
const STORE_MANUFACTURER_SUCCESS = 'efes/manufacturers/STORE_MANUFACTURER_SUCCESS';
const UPDATE_MANUFACTURER_SUCCESS = 'efes/manufacturers/UPDATE_MANUFACTURER_SUCCESS';
const REMOVE_MANUFACTURER_SUCCESS = 'efes/manufacturers/REMOVE_MANUFACTURER_SUCCESS';

const GET_TRANSPORT_USAGE_TYPES = 'efes/manufacturers/GET_TRANSPORT_USAGE_TYPES';
const GET_TRANSPORT_USAGE_TYPES_SUCCESS = 'efes/manufacturers/GET_TRANSPORT_USAGE_TYPES_SUCCESS';
const GET_TRANSPORT_USAGE_TYPES_FAIL = 'efes/manufacturers/GET_TRANSPORT_USAGE_TYPES_FAIL';

const initialState = {
  vehicles: { data: [], total: 0 },
  manufacturers: { data: [], total: 0 },
  isLoading: false,
  error: null,
  transportUsageTypes: [],
  isFetchingTransportUsageTypes: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case START_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case REQUEST_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    case GET_VEHICLES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        vehicles: action.result,
      };
    case STORE_VEHICLE_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const { transportModel } = action.result;
      // eslint-disable-next-line no-case-declarations
      const newData = {
        manufacturerName: transportModel.manufacturerName,
        modelName: transportModel.name,
      };
      return {
        ...state,
        isLoading: false,
        vehicles: { ...state.vehicles, data: [newData, ...state.vehicles.data] },
      };
    case UPDATE_VEHICLE_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const tModel = action.result.transportModel;
      // eslint-disable-next-line no-case-declarations
      const updatedData = { manufacturerName: tModel.manufacturerName, modelName: tModel.name };
      return {
        ...state,
        isLoading: false,
        vehicles: {
          ...state.vehicles,
          data: state.vehicles.data.map((v) => (v.modelId === tModel.id ? updatedData : v)),
        },
      };
    case REMOVE_VEHICLE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        vehicles: {
          ...state.vehicles,
          data: state.vehicles.data.filter((v) => v.modelId !== action.result),
        },
      };
    case GET_MANUFACTURERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        manufacturers: action.result,
      };
    case STORE_MANUFACTURER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        manufacturers: action.result,
      };
    case UPDATE_MANUFACTURER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        manufacturers: {
          ...state.manufacturers,
          data: state.manufacturers.data.map(
            (m) => (m.id === action.result.id ? action.result : m),
          ),
        },
      };
    case REMOVE_MANUFACTURER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        manufacturers: {
          ...state.manufacturers,
          data: state.manufacturers.data.filter((m) => m.id !== action.result),
        },
      };
    case GET_TRANSPORT_USAGE_TYPES:
      return {
        ...state,
        isFetchingTransportUsageTypes: true,
      };
    case GET_TRANSPORT_USAGE_TYPES_SUCCESS:
      return {
        ...state,
        transportUsageTypes: action.result.data,
        isFetchingTransportUsageTypes: false,
      };
    case GET_TRANSPORT_USAGE_TYPES_FAIL:
      return {
        ...state,
        isFetchingTransportUsageTypes: false,
      };
    default:
      return state;
  }
}

export function getVehicles({ params, filters }) {
  return {
    actions: [
      { type: START_REQUEST },
      { type: GET_VEHICLES_SUCCESS },
      { type: REQUEST_FAIL, showError: true },
    ],
    promise: getVehiclesData(params, filters),
  };
}

export function storeVehicle(payload) {
  return {
    actions: [
      { type: START_REQUEST },
      { type: STORE_VEHICLE_SUCCESS },
      { type: REQUEST_FAIL },
    ],
    promise: storeVehicleModel(payload),
  };
}

export function updateVehicle(payload) {
  return {
    actions: [
      { type: START_REQUEST },
      { type: UPDATE_VEHICLE_SUCCESS },
      { type: REQUEST_FAIL },
    ],
    promise: updateVehicleModel(payload),
  };
}

export function removeVehicle(payload) {
  return {
    actions: [
      { type: START_REQUEST },
      { type: REMOVE_VEHICLE_SUCCESS },
      { type: REQUEST_FAIL, showError: true },
    ],
    promise: removeVehicleModel(payload),
  };
}

export function getManufacturers({ params, filters }) {
  return {
    actions: [
      { type: START_REQUEST },
      { type: GET_MANUFACTURERS_SUCCESS },
      { type: REQUEST_FAIL, showError: true },
    ],
    promise: getManufacturersData(params, filters),
  };
}

export function storeManufacturer(payload) {
  return {
    actions: [
      { type: START_REQUEST },
      { type: STORE_MANUFACTURER_SUCCESS },
      { type: REQUEST_FAIL },
    ],
    promise: storeManufacturerData(payload),
  };
}

export function updateManufacturer(payload) {
  return {
    actions: [
      { type: START_REQUEST },
      { type: UPDATE_MANUFACTURER_SUCCESS },
      { type: REQUEST_FAIL },
    ],
    promise: updateManufacturerData(payload),
  };
}

export function removeManufacturer(payload) {
  return {
    actions: [
      { type: START_REQUEST },
      { type: REMOVE_MANUFACTURER_SUCCESS },
      { type: REQUEST_FAIL, showError: true },
    ],
    promise: removeManufacturerData(payload),
  };
}

export const getTransportUsageTypes = (contractType) => (dispatch) => dispatch({
  actions: [
    { type: GET_TRANSPORT_USAGE_TYPES },
    { type: GET_TRANSPORT_USAGE_TYPES_SUCCESS },
    { type: GET_TRANSPORT_USAGE_TYPES_FAIL },
  ],
  promise: transportUsageTypesRequest(contractType),
});
